import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen grid place-items-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-lg w-full text-center">
        <XCircle size={56} className="mx-auto text-[#FF8473]" />
        <h1 className="mt-8 font-display font-black text-5xl uppercase tracking-tight text-[#EBE6E0]">
          Checkout cancelled
        </h1>
        <p className="mt-4 text-lg text-[#FFFFFF]">
          No worries—your card wasn't charged. The campaign is still live whenever you're ready.
        </p>
        <button
          data-testid="cancel-back-btn"
          onClick={() => navigate("/#join")}
          className="mt-10 inline-flex items-center bg-[#D7E85C] text-[#1F3864] px-7 py-3 rounded-full font-bold uppercase text-sm hover:bg-[#EBE6E0] active:scale-95 transition-[background,transform] duration-200"
        >
          Back a tier
        </button>
      </div>
    </div>
  );
}
